<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol sm="4">
                    <div class="autocomplete">
                        <input type="text"
                                class="form-control"
                                @click="toggleVisiblePegawaiSearch()"
                                @blur="toggleCloseVisiblePegawaiSearch()"
                                v-model="queryPegawaiSearch"
                                v-text="selectedItemPegawaiSearch ? selectedItemPegawaiSearch['text'] : ''"
                                @keydown.up="upPegawaiSearch"
                                @keydown.down="downPegawaiSearch"
                                @keydown.enter="selectItemPegawaiSearch"
                                placeholder="Pilih Pegawai"
                        >
                        <div class="popovers" v-show="visiblePegawaiSearch">
                            <div class="options" v-if="matchesPegawaiSearch.length != 0 && queryPegawaiSearch.length != 0" ref="optionsList">
                                <ul>
                                <li v-for="(match, index) in matchesPegawaiSearch"
                                    :key="index"
                                    :class="{ 'selected': (selectedPegawaiSearch == index)}"
                                    @click="itemClickedPegawaiSearch(index)"
                                    v-text="match['text']"></li>
                                </ul>
                            </div>
                            <div class="options" v-if="matchesPegawaiSearch.length == 0 && queryPegawaiSearch.length != 0">
                                Data Tidak Ditemukan
                            </div>
                            <div class="options" v-if="matchesPegawaiSearch.length == 0 && queryPegawaiSearch.length == 0">
                                Start Typing...
                            </div>
                        </div>
                    </div>
                </CCol>
                <CCol sm="3">
                    <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataSearchTipe" class="form-control" v-model="selectedSearchTipe" placeholder="Tipe Keluarga"></model-select>
                </CCol>
                <CCol sm="3">
                    <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataSearchStatus" class="form-control" v-model="selectedSearchStatus" placeholder="Status"></model-select>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="6"></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-5 mt-1" v-if="datas.length != 0" @click="getDownload()" style="float:right;cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
                    <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    </div>
    <div v-else class="area-edit">
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <CRow>
                    <CCol sm="6">
                        <label>Nama Pegawai</label>
                        <input 
                            class="form-control mr-2" 
                            style="background-color:whitesmoke"
                            v-model="namaPegawai"
                            placeholder="Nama Pegawai" 
                            disabled
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Nama Pasangan</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.nama.$model"
                            :class="{ 'is-invalid':$v.nama.$error, 'is-valid': !$v.nama.$invalid }"
                            placeholder="Nama Pasangan"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Tipe</label>
                        <model-select :options="dataTipe"
                            class="form-control model-select"
                            v-model.trim="$v.selectedTipe.$model"
                            :class="{ 'is-invalid select-invalid':$v.selectedTipe.$error, 'is-valid select-valid': !$v.selectedTipe.$invalid }"
                            placeholder="Pilih Tipe">
                        </model-select>
                    </CCol>
                    <CCol sm="6">
                        <label>Tanggal Lahir</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.tglLahir.$model"
                            :class="{ 'is-invalid':$v.tglLahir.$error, 'is-valid': !$v.tglLahir.$invalid }"
                            placeholder="Tanggal Lahir"
                            type="date"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Status</label>
                        <model-select :options="dataStatus"
                            class="form-control model-select"
                            v-model.trim="$v.selectedStatus.$model"
                            :class="{ 'is-invalid select-invalid':$v.selectedStatus.$error, 'is-valid select-valid': !$v.selectedStatus.$invalid }"
                            placeholder="Pilih Status">
                        </model-select>
                    </CCol>
                    <CCol sm="6" v-if="selectedTipe.value == 'S'">
                        <label>Tanggal Menikah</label>
                        <input 
                            class="form-control" 
                            v-model="tglMenikah"
                            placeholder="Tanggal Menikah"
                            type="date"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Nomor AdMedika</label>
                        <input 
                            class="form-control" 
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                            v-model="noAdmedika"
                            placeholder="No Admedika "
                            type="text"
                        />
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <CRow class="area-button-submit">
            <CCol sm="12">
                <CButton @click="submitForm()" class="btn btn-edit-submit">
                    <span v-if="loading == false">Submit</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
import Tables from '../../../component/tableKeluarga'
import {DataApi} from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
export default {
    components: {
        ModelSelect,
        Tables
    },
    mixins: [validationMixin],
    validations: {
        nama: {
            required
        },
        tglLahir: {
            required
        },
        // tglMenikah: {
        //     required,
        // },
        selectedTipe: {
            value: {
                required
            },
            text: {
                required
            }
        },
        selectedStatus: {
            value: {
                required
            },
            text: {
                required
            }
        },
    },
    data() {
        return {
            // data search select pegawai search
            dataPegawaiSearch: [],
            titlePegawaiSearch:"Pilih Pegawai",
            selectedItemPegawaiSearch: null,
            selectedPegawaiSearch: 0,
            queryPegawaiSearch: '',
            visiblePegawaiSearch: false,
            idPegawaiSearch: '',

            success: true,
            // datas
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            downloadIcon: require('../../../assets/menu/icon_download_excel.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            dataTh: ['Nama Pegawai', 'Tipe', 'Nama', 'Tanggal Lahir', 'Tanggal Menikah', 'Status', 'Action'],
            dataTd: ['namaPegawai', 'familyType', 'nama', 'birthDate', 'marriedDate', 'status', 'action'],
            styleTable: ['100px', '75px', '100px', '100px', '100px', '75px', '75px'],
            classReload: 'reloadOff',
            datas: [],
            goArea: true,
            loading: false,
            alertMess: '',
            currentAlertCounter: 0,
            constDay: 1,
            editSession: false,

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // data model
            namaPegawai: '',
            idPegawai: '',
            dataStatus: [],
            dataTipe: [],
            selectedTipe: {
                text: '',
                value: ''                
            },
            selectedStatus: {
                text: '',
                value: ''
            },
            tglLahir: '',
            tglMenikah: '',
            nama: '',
            unix: 0,
            noAdmedika: '',
            tipe: 'c',

            // filter
            searchValue: '',
            dataSearchStatus: [],
            dataSearchTipe: [],
            selectedSearchTipe: {
                text: '',
                value: ''                
            },
            selectedSearchStatus: {
                text: '',
                value: ''
            },

            // error
            errorMessage: '',
            flagSearch: false
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        queryPegawaiSearch() {
            this.flagSearch = true
            this.getDataPegawaiSearch()
        },
        selectedSearchStatus() {
            this.flagSearch = true
        },
        selectedSearchTipe() {
            this.flagSearch = true
        }
    },
    computed: {
        matchesPegawaiSearch() {
            if (this.queryPegawaiSearch == '') {
                return [];
            }
            return this.dataPegawaiSearch.filter((item) => item['text'].toLowerCase().includes(this.queryPegawaiSearch.toLowerCase()))
        }
    },
    methods: {
        /**
         * SEARCH SELECT PEGAWAI SEARCH
         */
        getDataPegawaiSearch() {
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 10,
                nama: this.queryPegawaiSearch,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: ''
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPegawaiSearch = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].idPegawai,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataPegawaiSearch.push(onPush)
                }
            })
        },
        toggleVisiblePegawaiSearch() {
            this.visiblePegawaiSearch = true;
        },
        hidePegawaiSearch() {
            this.visiblePegawaiSearch = false;
        },
        toggleCloseVisiblePegawaiSearch() {
            setTimeout(this.hidePegawaiSearch, 1000);
        },
        itemClickedPegawaiSearch(index) {
            this.selectedPegawaiSearch = index;
            this.selectItemPegawaiSearch();
        },
        selectItemPegawaiSearch() {
            if (!this.matchesPegawaiSearch.length) {
            return;
            }
            this.selectedItemPegawaiSearch = this.matchesPegawaiSearch[this.selectedPegawaiSearch];
            this.visiblePegawaiSearch = false;
            this.queryPegawaiSearch = this.selectedItemPegawaiSearch.text
            this.idPegawaiSearch = this.selectedItemPegawaiSearch.value
            if (this.shouldReset) {
            this.queryPegawaiSearch = '';
            this.selectedPegawaiSearch = 0;
            }
        },
        upPegawaiSearch() {
            if (this.selectedPegawaiSearch == 0) {
            return;
            }
            this.selectedPegawaiSearch -= 1;
            this.scrollToItemPegawaiSearch();
        },
        downPegawaiSearch() {
            if (this.selectedPegawaiSearch >= this.matchesPegawaiSearch.length - 1) {
            return;
            }
            this.selectedPegawaiSearch += 1;
            this.scrollToItemPegawaiSearch();
        },
        scrollToItemPegawaiSearch() {
            this.$refs.optionsList.scrollTop = this.selectedPegawaiSearch * this.itemHeight;
        },

        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.namaPegawai.toLowerCase() < b.namaPegawai.toLowerCase()) {
                        return -1
                    }
                    if (a.namaPegawai.toLowerCase() > b.namaPegawai.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.familyType.toLowerCase() < b.familyType.toLowerCase()) {
                        return -1
                    }
                    if (a.familyType.toLowerCase() > b.familyType.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.nama.toLowerCase() < b.nama.toLowerCase()) {
                        return -1
                    }
                    if (a.nama.toLowerCase() > b.nama.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 3) {
                function compare(a,b) {
                    if (a.birthDate.toLowerCase() < b.birthDate.toLowerCase()) {
                        return -1
                    }
                    if (a.birthDate.toLowerCase() > b.birthDate.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 4) {
                function compare(a,b) {
                    if (a.marriedDate.toLowerCase() < b.marriedDate.toLowerCase()) {
                        return -1
                    }
                    if (a.marriedDate.toLowerCase() > b.marriedDate.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 5) {
                function compare(a,b) {
                    if (a.status.toLowerCase() < b.status.toLowerCase()) {
                        return -1
                    }
                    if (a.status.toLowerCase() > b.status.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getDownload() {
            let limit = this.size
            let nama = this.queryPegawaiSearch.split(" - ")[0]
            let page = this.page
            let status = this.selectedSearchStatus.value
            let tipe = this.selectedSearchTipe.value

            let payload = {
                limit: limit,
                nama: nama,
                pageIn: page,
                status: status,
                tipe: tipe
            }
            DataApi.post("/export/pegawai/get/family", payload , {responseType: 'blob'})
            .then(res => {
                let response = res.data
                // let fileName = res.headers["content-disposition"].split("filename=")[1];
                const url = URL.createObjectURL(new Blob([response], {
                    type: 'application/vnd.ms-excel'
                }))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Keluarga')
                document.body.appendChild(link)
                link.click()
            })
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let limit = this.size
            let nama = this.queryPegawaiSearch.split(" - ")[0]
            let page = this.page
            let status = this.selectedSearchStatus.value
            let tipe = this.selectedSearchTipe.value

            let payload = {
                limit: limit,
                nama: nama,
                pageIn: page,
                status: status,
                tipe: tipe
            }
            DataApi.post("pegawai/get/family", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        getDataSearchTipe() {
            this.dataSearchTipe = [
                { text: 'Semua', value: '' },
                { text: 'Pasangan', value: 'S'},
                { text: 'Anak', value: 'K'},
                { text: 'Prinsipal', value: 'P'}
            ]
        },
        getDataSearchStatus() {
            this.dataSearchStatus = [
                { text: 'Semua', value: '' },
                { text: 'Active', value: 'A'},
                { text: 'Reject', value: 'R'},                
                { text: 'Delete', value: 'D'},
                { text: 'Pending', value: 'P'}
            ]
        },

        getDataTipe() {
            this.dataTipe = [
                { text: 'Pasangan', value: 'S'},
                { text: 'Anak', value: 'K'},
                { text: 'Prinsipal', value: 'P'}
            ]
        },
        getDataStatus() {
            this.dataStatus = [
                { text: 'Active', value: 'A'},
                { text: 'Reject', value: 'R'},                
                { text: 'Delete', value: 'D'},
                { text: 'Pending', value: 'P'}
            ]
        },
        findData() {
            this.getData()
        },
        reload() {
            this.queryPegawaiSearch = ''
            this.idPegawaiSearch = ''
            this.selectedSearchTipe.value = ''
            this.selectedSearchStatus.value = ''
            this.selectedSearchTipe.text = ''
            this.selectedSearchStatus.text = ''
            this.getDataSearchTipe()
            this.getDataSearchStatus()
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },

        /**
         * ADD DATA
         */
        moving() {
            setTimeout(this.moveArea, 300);
        },
        moveArea() {
            if(this.goArea == true) {
                this.goArea = false
            } else {
                this.goArea = true
                this.idPegawai = ''
                this.selectedTipe = []
                this.tglMenikah = ''
                this.tglLahir = ''
                this.nama = ''
                this.namaPegawai = ''
                this.noAdmedika = ''
                this.tipe = 'C'
                this.unix = 0
                this.urlFile = ''
                this.editSession = false
                this.getDataTipe()
                this.getDataStatus()
                this.$v.$reset()
            }
        },
        goSave() {
            let birthDate = this.tglLahir
            let familyType = this.selectedTipe.value
            let idPegawai = this.idPegawai
            let marriedDate = this.tglMenikah
            let nama = this.nama
            let status = this.selectedStatus.value
            let tipe = this.tipe
            let unix = this.unix
            let urlFile = this.urlFile
            let noKartu = this.noAdmedika

            let payload = {
                birthDate: birthDate,
                noKartu: noKartu,
                planId: "",
                familyType: familyType,
                idPegawai: idPegawai,
                marriedDate: marriedDate,
                nama: nama,
                status: status,
                urlFile: urlFile,
                tipe: tipe,
                unix: unix
            }
            DataApi.post("pegawai/save/family", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.getData()
                this.moving()
                this.loading = false
                this.currentAlertCounter = 7
            })
        },
        /**
         * EDIT DATA
         */
        editData(value) {
            this.editSession = true
            let generate = this.datas[value]
            this.idPegawai = generate.idPegawai
            this.tglMenikah = generate.marriedDate
            this.tglLahir = generate.birthDate
            this.nama = generate.nama
            this.namaPegawai = generate.namaPegawai
            this.unix = generate.unix
            this.urlFile = generate.urlFile
            this.noAdmedika = generate.noKartu

            let dataTipe = this.dataTipe
            let tipe = generate.familyType
            var i = 0
            for(i=0;i<dataTipe.length;i++) {
                if(tipe == dataTipe[i].value) {
                    this.selectedTipe.value = dataTipe[i].value
                    this.selectedTipe.text = dataTipe[i].text
                }
            }

            let dataStatus = this.dataStatus
            let status = generate.status
            var k = 0
            for(k=0;k<dataStatus.length;k++) {
                if(status == dataStatus[k].value) {
                    this.selectedStatus.value = dataStatus[k].value
                    this.selectedStatus.text = dataStatus[k].text
                }
            }

            this.tipe = 'U'
            this.moving()
        },

        /**
         * VALIDATE
         */
        submitForm() {
            this.$v.$touch()
            if(this.$v.$invalid) {
            } else {
                this.goSave()
                this.loading = true
            }
        },
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataTipe()
        this.getDataStatus()
        this.getDataSearchTipe()
        this.getDataSearchStatus()
        this.getDataPegawaiSearch()
    }
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
@media screen and (min-width: 1253px) and (max-width: 1358px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1168px) and (max-width: 1252px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1097px) and (max-width: 1167px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1036px) and (max-width: 1096px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 992px) and (max-width: 1035px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1359px){
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}

.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}

.btn-delete {
    border-radius: 4px;
    float: right;
    width: 160px;
    margin-left: 4px;
    border: 1px solid 	#DC143C;
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-delete:hover {
    border-radius: 4px;
    float: right;
    width: 160px;
    margin-left: 4px;
    border: 1px solid 	#DC143C;
    background-color: 	#DC143C;
    color: white;
}

.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}

.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 32px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
</style>